import { useState } from "react"
import CodesValuesScreen from "../../screen/CodesValuesScreen"
import { useEffect } from "react"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import { removeDuplicatedArray } from "../../core/utils/manipulateArrays"
import { useScope } from "../SelectProjectCompanyContainer"

/* const filterByQuestionId = esmId === '7ea1de77-706a-413f-a9da-cb6f82febcbc' ? [
  { id: '0cd3eb12-1cf3-49a4-8902-06f4a3a884b0', name: 'ID' },
  { id: '872818c1-e9a4-48b7-b980-17b18e9fc9a6', name: 'Ano' },
  { id: '99f759e5-8de5-4d15-955e-b957988f9794', name: 'Profundidade' },
  { id: '358e2c32-d238-4832-86ce-6916c8d38eed', name: 'Empreendimento' },
  { id: '0365ae71-508e-419e-af52-31a3e6f61005', name: 'UF' },
  { id: '4d038f0e-c48f-466b-8c6b-61d5dbc80cd5', name: 'Biomas' },
] : []; */

const CodesValuesContainer = ({
  esmId,
  setValues,
  setResponseCodesSearch,
  values,
  isSearch,
  setIsSearch,
  setLoadingSearch,
  loadingSearch,
  resetFields,
  setResetFields,
  isProcessingUser = false,
  onClearLocalFilters,
}) => {
  const { projectsByScope, scope, scopeType } = useScope()
  const [codesValues, setCodesValues] = useState([])
  const [codesSelect, setCodesSelect] = useState([])

  const filterByQuestionId =
    esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
      ? [
          {
            id: "0cd3eb12-1cf3-49a4-8902-06f4a3a884b0",
            name: "ID",
            type: "select-creatable",
            isMulti: "true",
          },
          {
            id: "872818c1-e9a4-48b7-b980-17b18e9fc9a6",
            name: "Ano",
            type: "select-creatable",
            isMulti: "true",
          },
          {
            id: "99f759e5-8de5-4d15-955e-b957988f9794",
            name: "Profundidade",
            type: "select-creatable",
            isMulti: "true",
          },
          {
            id: "358e2c32-d238-4832-86ce-6916c8d38eed",
            name: "Empreendimento",
            type: "select-creatable",
            isMulti: "true",
          },
          {
            id: "0365ae71-508e-419e-af52-31a3e6f61005",
            name: "UF",
            type: "select",
            isMulti: "false",
          },
          {
            id: "4d038f0e-c48f-466b-8c6b-61d5dbc80cd5",
            name: "Biomas",
            type: "select-creatable",
            isMulti: "true",
          },
        ]
      : []

  const filterQuestionsByCode = [
    {
      "872818c1-e9a4-48b7-b980-17b18e9fc9a6": [{ value: "2021", label: "2021" }],
      "0cd3eb12-1cf3-49a4-8902-06f4a3a884b0": [
        { value: "INV078", label: "INV078" },
        { value: "INV032", label: "INV032" },
        { value: "INV035", label: "INV035" },
        { value: "INV0111", label: "INV0111" },
        { value: "INV0", label: "INV0" },
        { value: "INV078", label: "INV078" },
      ],
      "99f759e5-8de5-4d15-955e-b957988f9794": [
        { value: "20", label: "20" },
        { value: "40", label: "40" },
      ],
      "358e2c32-d238-4832-86ce-6916c8d38eed": [
        { value: "INO-SP0022-01", label: "INO-SP0022-01" },
        { value: "INO-SP0009-01", label: "INO-SP0009-01" },
        { value: "INO-SP0031-01", label: "INO-SP0031-01" },
        { value: "INO-SP0032-01", label: "INO-SP0032-01" },
      ],
      "0365ae71-508e-419e-af52-31a3e6f61005": [{ value: "SP", label: "SP" }],
      "4d038f0e-c48f-466b-8c6b-61d5dbc80cd5": [
        { value: "101", label: "Amazônia" },
        { value: "101", label: "Caatinga" },
        { value: "101", label: "Cerrado" },
        { value: "101", label: "Mata Atlântica" },
        { value: "101", label: "Pampa " },
        { value: "10", label: "Pantanal " },
      ],
    },
  ]

  useEffect(() => {
    if (filterByQuestionId && filterByQuestionId.length && !codesValues.length) {
      setCodesValues([
        ...codesValues,
        ...filterByQuestionId.filter(
          (item) => !codesValues.map((code) => code?.id).includes(item.id),
        ),
      ])
    }
  }, [filterByQuestionId])

  const removeQuestions = (originalArray, filterArray, property) => {
    return originalArray.filter(
      (item) => !filterArray.some((filterItem) => filterItem[property] === item[property]),
    )
  }

  useEffect(() => {
    if (isProcessingUser && codesValues.length > 0) {
      setValues(null)
      setCodesSelect(null)
    }
  }, [isProcessingUser])

  useEffect(() => {
    if (codesSelect && codesSelect.length) {
      setResetFields(false)
    }
  }, [codesSelect])

  const searchEsm = async () => {
    try {
      setLoadingSearch(true)
      let response = []
      const codeValues = removeDuplicatedArray(codesValues, "id" || "code" || "value")
      const filteredCodeValues = removeQuestions(codeValues, filterByQuestionId, "id")
      const groupedCodes = groupSelectByCode(codesSelect)
      const mergedArr = [...filteredCodeValues, ...groupedCodes]

      const checkCodeSelect = mergedArr.some((cd) => cd?.value !== "" || cd?.values?.length > 0)
        ? mergedArr
        : []

      if (checkCodeSelect.length) {
        response = await Send.post("/ia/producersByCode", {
          code: checkCodeSelect,
          projects: projectsByScope
            .map((item) => item.id)
            .map((item) => `'${item}'`)
            .join(","),
        })
        
        if (response && Array.isArray(response)) {
          setResponseCodesSearch({
            data: response,
          })

          customToast("Dados filtrados!", "success")
        } else {
          throw new Error(response)
        }
      }
    } catch (error) {
      console.error(error)
    }
    setIsSearch(false)
    setLoadingSearch(false)
  }

  useEffect(() => {
    if (isSearch && codesValues.length > 0) {
      searchEsm()
    }
  }, [isSearch, codesValues])

  const groupSelectByCode = (codeSelect) => {
    return Object.values(
      codeSelect.reduce((result, currentItem) => {
        const id = currentItem.code

        if (!result[id]) {
          result[id] = { id, values: [] }
        }

        result[id].values.push(currentItem.value)

        return result
      }, {}),
    )
  }

  const handleChangeCodes = (data, e, id) => {
    if (e && e?.action) {
      if (e.action === "select-option") {
        const values = data.map(({ value, label }) => ({ code: id, value, label }))
        const newCodesValues = [
          ...codesSelect,
          ...values.filter(
            (item) => !codesSelect.some((i) => i.value == item.value && i.code == item.code),
          ),
        ]
        setCodesSelect(newCodesValues)
        setValues(newCodesValues)
      } else {
        const newCodesValues = codesSelect.filter((item) => item.value !== e?.removedValue?.value)
        setCodesSelect(newCodesValues)
        setValues(newCodesValues)
      }
    } else {
      const newCodesValues = [...codesValues]
      newCodesValues[data][e.target.name] = e.target.value
      setCodesValues(newCodesValues)
      setValues(!isSearch && newCodesValues)
    }
  }

  const addCodes = () => {
    const codeempty = { code: "", value: "", type: "text" }
    setCodesValues((prevCodesValues) => {
      const updatedCodesValues = [...prevCodesValues, codeempty]
      setValues(!isSearch && updatedCodesValues)
      return updatedCodesValues
    })
  }

  const removeCodes = (i, hasId) => {
    let newCodesValues = [...codesValues]

    if (hasId) {
      newCodesValues = newCodesValues.filter((row) => row.id && row.id !== hasId)
    } else {
      newCodesValues.splice(i, 1)
    }

    setCodesValues(newCodesValues)
    setValues(!isSearch && newCodesValues)
  }

  const handleChangeInputCodesSelect = (newValue, actionMeta, id) => {
    if (actionMeta.action == "set-value") {
      setCodesSelect([
        ...codesSelect,
        {
          code: id,
          value: newValue || actionMeta.prevInputValue,
        },
      ])
    }
  }

  return (
    <CodesValuesScreen
      {...{
        esmId,
        codesValues,
        values,
        codesSelect,
        resetFields: resetFields || isProcessingUser,
        removeCodes,
        isProcessingUser,
        handleChangeCodes,
        handleChangeInputCodesSelect,
        addCodes,
        loadingSearch,
        filterQuestionsByCode,
      }}
    />
  )
}

export default CodesValuesContainer
